export default function Products() {
  const products = [
    {
      name: 'PIM-OIL (Pain Magic)',
      benefits: [
        'Fast relief for muscle pain and tension',
        'Effective for toothaches and headaches',
        'Supports respiratory health',
        'Natural anti-inflammatory properties',
      ],
      image: 'https://public.readdy.ai/ai/img_res/e94bed8d681196f983f267ed812b3033.jpg',
    },
    {
      name: 'Magnesium Gel + Aloe',
      benefits: [
        'Soothes joint pain and inflammation',
        'Reduces muscle cramps and spasms',
        'Aids relaxation and recovery',
        'Gentle on sensitive skin',
      ],
      image: 'https://readdy.ai/api/search-image?query=magnesium%20gel%20tube%20with%20aloe%20vera%20topical%20cream%20product%20on%20white%20background%20clean%20medical%20packaging%20healthcare%20supplement%20professional%20product%20photography%20minimalist%20style&width=400&height=400&seq=product-gel-002&orientation=squarish',
    },
    {
      name: 'Calcium, Mag &amp; Zinc with Vitamin D',
      benefits: [
        'Supports strong bone health',
        'Enhances muscle function',
        'Boosts immune system',
        'Promotes overall wellness',
      ],
      image: 'https://readdy.ai/api/search-image?query=vitamin%20supplement%20bottle%20calcium%20magnesium%20zinc%20tablets%20white%20container%20on%20clean%20background%20professional%20healthcare%20product%20photography%20medical%20supplement%20packaging%20minimalist%20style&width=400&height=400&seq=product-vitamin-003&orientation=squarish',
    },
    {
      name: 'Dokudami Capsules',
      benefits: [
        'Natural detoxification support',
        'Antimicrobial properties',
        'Respiratory system support',
        'Immune system enhancement',
      ],
      image: 'https://readdy.ai/api/search-image?query=herbal%20supplement%20capsules%20bottle%20natural%20medicine%20dokudami%20extract%20white%20container%20on%20clean%20background%20professional%20healthcare%20product%20photography%20medical%20supplement%20minimalist%20style&width=400&height=400&seq=product-capsule-004&orientation=squarish',
    },
    {
      name: 'Vitamin B12 Complex',
      benefits: [
        'Essential for energy production',
        'Supports nerve function',
        'Promotes bone strength',
        'Enhances cognitive health',
      ],
      image: 'https://readdy.ai/api/search-image?query=vitamin%20b12%20supplement%20bottle%20tablets%20white%20container%20on%20clean%20background%20professional%20healthcare%20product%20photography%20medical%20supplement%20packaging%20minimalist%20style&width=400&height=400&seq=product-b12-005&orientation=squarish',
    },
    {
      name: 'Complete Wellness Bundle',
      benefits: [
        'Comprehensive nutritional support',
        'Synergistic supplement combination',
        'Optimized for recovery',
        'Value-packed solution',
      ],
      image: 'https://readdy.ai/api/search-image?query=multiple%20supplement%20bottles%20wellness%20bundle%20healthcare%20products%20arranged%20together%20on%20white%20background%20professional%20product%20photography%20medical%20supplements%20minimalist%20clean%20style&width=400&height=400&seq=product-bundle-006&orientation=squarish',
    },
  ];

  return (
    <section id="products" className="py-20 bg-gradient-to-b from-white to-[#F0F9FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0B4F6C] mb-4">
            Nutritional Supplements &amp; Counter Products
          </h2>
          <div className="w-20 h-1 bg-[#14B8A6] mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Supporting your recovery from the inside out with premium quality supplements
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer"
            >
              <div className="relative w-full h-64 bg-gradient-to-br from-[#F0F9FF] to-white overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain object-center p-6 group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-[#0B4F6C] mb-4 group-hover:text-[#14B8A6] transition-colors">
                  {product.name}
                </h3>
                <ul className="space-y-2">
                  {product.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start space-x-2 text-sm text-gray-600">
                      <i className="ri-checkbox-circle-fill text-[#14B8A6] mt-0.5 flex-shrink-0"></i>
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full mt-6 bg-[#14B8A6] text-white py-3 rounded-lg text-sm font-semibold hover:bg-[#0D9488] transition-colors whitespace-nowrap"
                >
                  Inquire Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}